// Config que vem do ambiente, não do build.
//
// O bundle do Vite é estático: uma variável de ambiente do Kubernetes não chega
// no browser. O servidor resolve isso injetando window.__DOCS_CONFIG__ no
// index.html antes do bundle carregar — assim trocar o domínio, ou subir um
// ambiente paralelo, é mudar env e reiniciar o pod, sem rebuild nem republicar
// imagem.
//
// Os padrões abaixo valem para `npm run dev`, onde não há servidor injetando
// nada. Nunca deixe um padrão que só faz sentido na máquina de quem escreveu:
// se ele vazar para produção, tem que continuar correto.

import { expandirTokens, SITE_URL_PADRAO } from "../../shared/constants.js";

const injetada = typeof window !== "undefined" ? window.__DOCS_CONFIG__ : undefined;

export const runtime = {
  // URL pública do site, sem barra no fim.
  siteUrl: (injetada?.siteUrl ?? SITE_URL_PADRAO).replace(/\/+$/, ""),
  // Caminho do endpoint MCP no mesmo domínio.
  mcpPath: injetada?.mcpPath ?? "/api/mcp",
};

/** URL completa do endpoint MCP, para exibir nas instruções de configuração. */
const mcpUrl = `${runtime.siteUrl}${runtime.mcpPath}`;

// Os dois tokens que só existem em runtime. O resto do mapa (sandbox, motor,
// exemplos, `{YOUR_DOMAIN}`) vive em shared/constants.ts, porque o servidor MCP
// também precisa dele para os guias de mcp/guides.
const doAmbiente: Record<string, string> = { "{SITE_URL}": runtime.siteUrl, "{MCP_URL}": mcpUrl };

/**
 * Troca os tokens escritos nos .mdx pelo valor real.
 *
 * Escrever `{SITE_URL}/api/mcp` no conteúdo mantém o texto legível na fonte e
 * correto em qualquer ambiente. `locale` escolhe a variante de `{YOUR_DOMAIN}`.
 */
export function aplicarTokens(texto: string, locale?: string): string {
  return expandirTokens(texto, doAmbiente, locale);
}
